var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplaintWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#185edf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m18.69 13.33-.12.52h-2.63c0-.17.05-.35.07-.52h-.91c0 .17 0 .35-.08.52h-2.57v-2.33h-.09a1.78 1.78 0 0 1-.82-.21v2.54h-1a2 2 0 0 0-1.75-1.54A11.05 11.05 0 0 1 9 10.15h1.7v-.9H9.18a8.8 8.8 0 0 1 .36-1.06 6.84 6.84 0 0 1 1.13-1.86V5.09a1.63 1.63 0 0 1 .17-.73 7.72 7.72 0 1 0 8.8 8.8 9 9 0 0 0 .08-2.08 1.26 1.26 0 0 1-.8.29 12.86 12.86 0 0 1-.23 1.96zm-9 1a1.12 1.12 0 1 1-1.11-1.12 1.11 1.11 0 0 1 1.14 1.12zM7.17 7.18a6.79 6.79 0 0 1 3.15-1.79A7.43 7.43 0 0 0 8.7 7.84a10.12 10.12 0 0 0-.46 1.41H5.75a7 7 0 0 1 1.42-2.07zM5.18 12a6.77 6.77 0 0 1 .25-1.85h2.63a11.45 11.45 0 0 0-.14 2.27 2 2 0 0 0-1.28 1.43H5.43A6.77 6.77 0 0 1 5.18 12zm2 4.82a7 7 0 0 1-1.42-2.07h.88a2 2 0 0 0 2 1.6h.17a7.26 7.26 0 0 0 1.51 2.27 6.78 6.78 0 0 1-3.15-1.8zm4.37 1.66a5.91 5.91 0 0 1-1.9-2.42 2 2 0 0 0 .94-1.31h1zm.91 0v-3.73h2.37a7.74 7.74 0 0 1-.3.89 6.22 6.22 0 0 1-2.08 2.83zm4.37-1.65a6.8 6.8 0 0 1-3.14 1.79A7.59 7.59 0 0 0 15.37 16a9.62 9.62 0 0 0 .38-1.22h2.49a6.77 6.77 0 0 1-1.42 2.04z",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.85 5.15V10h-2l-.27.32-1 1.29-1-1.27-.27-.34h-2.08V5.15h6.62m.2-.88H12a.69.69 0 0 0-.68.68v5.24a.68.68 0 0 0 .68.67h1.85l1.28 1.67a.49.49 0 0 0 .38.18.48.48 0 0 0 .37-.17l1.36-1.68h1.78a.67.67 0 0 0 .67-.67V5a.68.68 0 0 0-.67-.68z",
    style: {
      opacity: 0.9,
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.54 8.49a.45.45 0 0 1-.45-.49V6A.45.45 0 1 1 16 6v2a.45.45 0 0 1-.46.49zm0 1.36a.45.45 0 0 1-.45-.45v-.06a.45.45 0 0 1 .9 0v.06a.45.45 0 0 1-.45.45z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintWebsite);
export default __webpack_public_path__ + "static/media/complaint-website.daf78f42d95e7744665233975e0a826e.svg";
export { ForwardRef as ReactComponent };